import { checkBeforeEnter } from '@/auth/utils';

export default [
    {
        path: '/usuarios',
        name: 'user-management-list',
        component: () => import('@/views/modules/user-management/user-management-list/UserManagementList.vue'),
        beforeEnter: (to, from, next) => { checkBeforeEnter(['isSuperAdmin', 'isAdmin'], to, from, next) },
        meta: {
            resource: 'ACL',
            pageTitle: 'Usuarios',
            breadcrumb: [{
                text: 'Lista de usuarios',
                active: true
            }],
            requiresAuth: true
        }
    },
    {
        path: '/usuarios/nuevo',
        name: 'user-management-create',
        component: () => import ('@/views/modules/user-management/user-management-store/UserManagementStore.vue'),
        beforeEnter: (to, from, next) => { checkBeforeEnter(['isSuperAdmin', 'isAdmin'], to, from, next) },
        meta: {
            resource: 'ACL',
            pageTitle: 'Usuarios',
            breadcrumb: [{
				text: 'Lista de usuarios',
				to: {
					name: 'user-management-list',
				}
			},{
                text: 'Nuevo usuario',
                active: true
            }],
            requiresAuth: true
        }
    },
    {
        path: '/usuarios/configuracion-aprobaciones',
        name: 'approval-config',
        component: () => import('@/views/modules/user-management/approval-config/ApprovalConfig.vue'),
        beforeEnter: (to, from, next) => { checkBeforeEnter(['isSuperAdmin', 'isAdmin'], to, from, next) },
        meta: {
            resource: 'ACL',
            pageTitle: 'Usuarios',
            breadcrumb: [{
				text: 'Lista de usuarios',
				to: {
					name: 'user-management-list',
				}
			},{
                text: 'Configuración de Aprobaciones',
                active: true
            }],
            requiresAuth: true
        }
    },
    {
        path: '/usuarios/:id/editar',
        name: 'user-management-edit',
        component: () => import ('@/views/modules/user-management/user-management-edit/UserManagementEdit.vue'),
        beforeEnter: (to, from, next) => { checkBeforeEnter(['isSuperAdmin', 'isAdmin'], to, from, next) },
        meta: {
            resource: 'ACL',
            pageTitle: 'Usuarios',
			breadcrumb: [{
				text: 'Lista de usuarios',
				to: {
					name: 'user-management-list',
				}
			},{
                text: 'Editar usuario',
                active: true
            }],
            requiresAuth: true
        }
    }
]
